"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hocs_1 = require("../hocs");
var PollerManager_1 = __importDefault(require("./PollerManager"));
/** @deprecated Use `usePoller` instead */
function withPolling(options) {
    return function (WrappedComponent) {
        var Polling = /** @class */ (function (_super) {
            __extends(Polling, _super);
            function Polling() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            /**
             * We create/get poller before render wrapped component
             * because wrapped component could take poller for call pollerVariables
             */
            Polling.prototype.UNSAFE_componentWillMount = function () {
                var pollerName = options.pollerName, executableAction = options.executableAction, ownPollerManager = options.pollerManager;
                var pollerManager = ownPollerManager || PollerManager_1.default();
                var poller = pollerManager.get(pollerName);
                if (!poller) {
                    if (executableAction) {
                        this.poller = pollerManager.create({
                            dispatch: this.store.dispatch,
                            name: pollerName,
                            actionCreator: executableAction,
                        });
                    }
                }
                else {
                    this.poller = poller;
                }
            };
            // After wrapped component rendered (pollerVariables) we enable poller
            Polling.prototype.componentDidMount = function () {
                var skipInitialRequest = options.skipInitialRequest;
                if (!skipInitialRequest) {
                    return this.poller.enable();
                }
                var skipRequest = typeof skipInitialRequest === 'function'
                    ? skipInitialRequest(this.props)
                    : skipInitialRequest;
                this.poller.enable({ skipRequest: skipRequest });
            };
            Polling.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
                if (nextProps.isPollingTurnedOff !==
                    this.props.isPollingTurnedOff) {
                    nextProps.isPollingTurnedOff
                        ? this.poller.disable()
                        : this.poller.enable({ skipRequest: true });
                }
            };
            Polling.prototype.componentWillUnmount = function () {
                this.poller.disable();
                this.poller.clearVariables();
            };
            Polling.prototype.render = function () {
                return (react_1.default.createElement(WrappedComponent, __assign({}, this.props, { poller: this.poller })));
            };
            return Polling;
        }(react_1.default.Component));
        return hocs_1.extendHOC(WrappedComponent, Polling, { withStore: true });
    };
}
exports.default = withPolling;
//# sourceMappingURL=withPolling.js.map